import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import clsx from 'clsx'

import { RoutingPaths } from 'app/routes/routes'

import {
  type ObjectBookingsHistoryTab,
  ObjectBookingsHistoryWidget,
  objectBookingsHistoryTabs,
} from 'widgets/kyrgyzstan/object-bookings'

import { HeaderGoBack } from 'shared/ui/header-go-back'

import s from './styles.module.scss'

const DEFAULT_TAB: ObjectBookingsHistoryTab = 'active'

const isObjectBookingsHistoryTab = (
  tab: string | null,
): tab is ObjectBookingsHistoryTab =>
  Boolean(
    tab && objectBookingsHistoryTabs.includes(tab as ObjectBookingsHistoryTab),
  )

const KyrgyzstanObjectBookingsHistoryPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get('tab')
  const activeTab = isObjectBookingsHistoryTab(tabParam)
    ? tabParam
    : DEFAULT_TAB

  useEffect(() => {
    if (tabParam === null || isObjectBookingsHistoryTab(tabParam)) {
      return
    }

    const nextParams = new URLSearchParams(searchParams)
    nextParams.set('tab', DEFAULT_TAB)
    setSearchParams(nextParams, { replace: true })
  }, [searchParams, setSearchParams, tabParam])

  const handleGoBack = () => {
    navigate(RoutingPaths.kyrgyzstan.objects.path())
  }

  const handleTabChange = (tab: ObjectBookingsHistoryTab) => {
    if (tab === activeTab) {
      return
    }

    const nextParams = new URLSearchParams(searchParams)
    nextParams.set('tab', tab)
    setSearchParams(nextParams, { replace: true })
  }

  return (
    <main className={s.page}>
      <HeaderGoBack
        variant="grey"
        buttonWhite
        title={t('kyrgyzstan_block.my_objects.bookings.history_page.title')}
        onGoBack={handleGoBack}
      />

      <div className={clsx('container', s.content)}>
        <ObjectBookingsHistoryWidget
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      </div>
    </main>
  )
}

export default KyrgyzstanObjectBookingsHistoryPage
